/**
 * 位置情報クラス
 */
export class MyGeolocation {
  /**
   * 現在位置取得処理
   */

  static getCurrentPosition(): Promise<GeolocationPosition> {
    return new Promise<GeolocationPosition>((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('geolocation not supported.'));
        return;
      }
      const geolocation = navigator.geolocation;
      const options: PositionOptions = {
        enableHighAccuracy: true,
        // maximumAge: number,
        // timeout: number,
      };
      geolocation.getCurrentPosition(
        (position) => resolve(position),
        (error) => reject(error),
        options
      );
    });
  }
}
